import styled, { css } from 'styled-components';
import { maxWidthDefault } from '../../../styles/utils';
import InfoTooltip from '../../../components/InfoTooltip';
import FilterWrapperMobile from '../../../components/FilterWrapperMobile';
import { TransactionFilterDiv } from '../../../components/TableFilterStyles';
import { SearchStaticDiv } from '../../../components/SearchStaticStyles';
import CsvFilter from '../../../components/CsvFilter';
import CalendarFilter from '../../../components/CalendarFilter';

export const FiltersDiv = styled.div`
  flex-grow: 1;
  max-width: 100%;
  margin-bottom: 10px;
  ${props =>
    props.titleRow &&
    css`
      @media screen and (min-width: 1024px) {
        max-width: 650px;
        margin-left: auto;
      }
    `}
  @media screen and (min-width: 1440px) {
    max-width: ${maxWidthDefault - 160}px;
  }
`;

export const FiltersSectionDiv = styled.div`
  display: flex;
  height: 4rem;
  align-items: flex-start;
  border: ${props => props.theme.defaultBorder};
  background-color: white;
  @media screen and (max-width: 767px) {
    margin-top: 1rem;
  }
  ${props =>
    props.payoutsMobileCustom &&
    css`
      border: 1px solid ${props => props.theme.brand};
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      padding: 0px 1.5rem;
      align-items: center;
      > p {
        color: ${props => props.theme.brand};
        margin-right: 1rem;
      }
    `}
`;

export const CustomInfoTooltip = styled(InfoTooltip)`
  padding-right: 6px;
  cursor: pointer;
`;

export const CustomFilterWrapperMobile = styled(FilterWrapperMobile)`
  /* @media screen and (max-width: 767px) {
    height: 217px;
    > div {
      height: 194px;
    }
  } */
`;

export const ReferredPartnerTransactionFilterDiv = styled(TransactionFilterDiv)`
  ${SearchStaticDiv} {
    width: 100%;
  }

  width: 350px;
  @media screen and (min-width: 1440px) {
    width: 727px;
  }
  input {
    padding-bottom: 0;
  }
  svg {
    top: 2px;
  }
  && {
    max-width: unset;
  }
  &:focus-within {
    border-bottom: 1px solid ${props => props.theme.brand};
  }
`;

export const CustomCsvFilter = styled(CsvFilter)`
  width: 168px;
  justify-content: center;
  @media screen and (min-width: 1440px) {
    width: 158px;
  }
`;

export const CustomCalendarFilter = styled(CalendarFilter)`
  /* width: 205px;
  ${props =>
    props.calendarStart &&
    props.calendarEnd &&
    css`
      justify-content: space-between;
    `} */
`;
